import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tablero-programador-finished-pending-ssta',
  templateUrl: './tablero-programador-finished-pending-ssta.component.html',
  styleUrls: ['./tablero-programador-finished-pending-ssta.component.scss']
})
export class TableroProgramadorFinishedPendingSstaComponent implements OnInit {

  @Input()
  programadores: any = 
  {
    programadores : [
      {
        nombre: 'programador1',
        totalSinFinalizar: 0,
        tiempoPromedioSinFinalizar: 0,
        sstaXDias: 0
      },
    ],
    sstaXDiasFiltrado: 0
  }

  @Output()
  eventEmitterUserFilterSearch: EventEmitter<any> = new EventEmitter();
  
  @Output()
  eventEmitterRedirectToSSTAReportByProgrammer: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  searchLocalStorageSsta(user: any, status?: any) {
    this.eventEmitterUserFilterSearch.emit({ user, status })
  }

  redirectToSSTAReportByProgrammer(programmerName: any, hasDays: any) {
    this.eventEmitterRedirectToSSTAReportByProgrammer.emit({ programmerName, hasDays })
  }
}
